"use client"

import { useEffect, useState } from "react"
import {
  Box,
  Typography,
  TextField,
  Button,
  Autocomplete,
  Card,
  CardContent,
  Divider,
  FormControlLabel,
  Checkbox,
  Switch,
  Collapse,
  IconButton,
  Tooltip,
  InputAdornment,
  Tabs,
  Tab,
  alpha,
  useTheme,
} from "@mui/material"
import {
  Close as CloseIcon,
  Person as PersonIcon,
  Receipt as ReceiptIcon,
  Payments as PaymentsIcon,
  PointOfSale as PointOfSaleIcon,
  Visibility as VisibilityIcon,
  RestartAlt as RestartAltIcon,
  FmdGood as FmdGoodIcon,
  Storefront as StorefrontIcon,
} from "@mui/icons-material"

const VentaCrearMobilePanel = ({
  // Drawer controls
  initialTab,
  onTabChange,
  onClose,
  onGoToPreventa,
  // Config
  dniCliente,
  setDniCliente,
  searchTextCliente,
  setSearchTextCliente,
  entidadesClientesTresLetras,
  selectedUbicacion,
  setSelectedUbicacion,
  ubicaciones,
  selectedNegocio,
  setSelectedNegocio,
  negocios,
  usuarioSeleccionado,
  setUsuarioSeleccionado,
  usuarios,
  checkboxFacturaNegro,
  setCheckboxFacturaNegro,
  canGoToPayment,
  onGoToPayment,
  // Payment
  precioBaseTotal,
  precioTotal,
  aplicarDescuento,
  setAplicarDescuento,
  tempPorcentajeDescuento,
  setTempPorcentajeDescuento,
  applyDiscounts,
  limpiarDescuentosItems,
  montoTotalDescuentos,
  aplicarInteres,
  setAplicarInteres,
  tempPorcentajeInteres,
  setTempPorcentajeInteres,
  applyInterest,
  limpiarInteresesItems,
  montoTotalIntereses,
  aceptarImpuestos,
  impuestos,
  idTipoFactura,
  setIdTipoFactura,
  tiposFacturas,
  selectedTipoMedioDePago,
  setSelectedTipoMedioDePago,
  tipoMedioDePago,
  selectedMedioDePago,
  setSelectedMedioDePago,
  medioDePagoIdTipoEspecifico,
  openCollapse,
  mostrarButtonModalMedioDePago,
  handleAbrirModalMedioDePago,
  cantidaMedioDePagoList,
  onConfirmarPago,
  isConfirmDisabled,
}) => {
  const theme = useTheme()
  const [activeTab, setActiveTab] = useState(initialTab || "config")
  const [tipoSeleccionado, setTipoSeleccionado] = useState("venta")

  useEffect(() => {
    setActiveTab(initialTab || "config")
  }, [initialTab])

  const handleSetTab = (nextTab) => {
    setActiveTab(nextTab)
    if (onTabChange) onTabChange(nextTab)
  }

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#f5f5f5",
      }}
    >
      <Box
        sx={{
          p: 1,
          backgroundColor: "#5b5b5f",
          color: "white",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography sx={{ fontWeight: 700, fontSize: 14 }}>Venta</Typography>
        <IconButton onClick={onClose} sx={{ color: "white", p: 0.5 }}>
          <CloseIcon sx={{ fontSize: 18 }} />
        </IconButton>
      </Box>

      <Tabs
        value={activeTab}
        onChange={(_, nextValue) => handleSetTab(nextValue)}
        variant="fullWidth"
        sx={{
          minHeight: 34,
          "& .MuiTab-root": {
            minHeight: 34,
            py: 0.5,
            fontSize: 12,
          },
        }}
      >
        <Tab label="Configuracion" value="config" />
        <Tab label="Pago" value="payment" />
      </Tabs>

      <Box sx={{ flex: 1, overflow: "auto", p: 1 }}>
        {activeTab === "config" && (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            <Card elevation={2} sx={{ borderRadius: 1.5 }}>
              <CardContent sx={{ p: 1, "&:last-child": { pb: 1 } }}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={tipoSeleccionado === "venta"}
                      onChange={(event) => {
                        const isVenta = event.target.checked
                        const siguienteTipo = isVenta ? "venta" : "preventa"
                        setTipoSeleccionado(siguienteTipo)
                        if (!isVenta && onGoToPreventa) {
                          onGoToPreventa()
                        }
                      }}
                      size="small"
                    />
                  }
                  label={<Typography sx={{ fontSize: 12 }}>{tipoSeleccionado === "venta" ? "Venta" : "Preventa"}</Typography>}
                  sx={{ ml: 0, mb: 0.5 }}
                />
                <Typography sx={{ mb: 0.75, fontSize: 12, fontWeight: 700, display: "flex", alignItems: "center", gap: 0.5 }}>
                  <PersonIcon sx={{ fontSize: 16 }} />
                  Cliente
                </Typography>
                <Autocomplete
                  size="small"
                  disablePortal
                  options={entidadesClientesTresLetras.map((item) => ({
                    label: `${item.descripcion} ${item.apellido} ${item.dniCuitCuil}`,
                    descripcion: item.descripcion || null,
                    dniCuitCuil: item.dniCuitCuil,
                    id: item.id,
                    apellido: item.apellido,
                    telefono: item.telefono || null,
                    email: item.email || null,
                    direccion: item.direccion || null,
                    localidad: item.localidad || null,
                    provincia: item.provincia || null,
                    idTipoEntidad: item.idTipoEntidad,
                  }))}
                  value={dniCliente}
                  onChange={(event, newValue) => setDniCliente(newValue)}
                  onInputChange={(event, newValue) => setSearchTextCliente(newValue)}
                  renderInput={(params) => <TextField {...params} label="Cliente" />}
                />
              </CardContent>
            </Card>

            <Card elevation={2} sx={{ borderRadius: 1.5 }}>
              <CardContent sx={{ p: 1, "&:last-child": { pb: 1 } }}>
                <Typography sx={{ mb: 0.75, fontSize: 12, fontWeight: 700, display: "flex", alignItems: "center", gap: 0.5 }}>
                  <FmdGoodIcon sx={{ fontSize: 16 }} />
                  Ubicacion y negocio
                </Typography>

                <Box sx={{ display: "flex", flexDirection: "column", gap: 0.75 }}>
                  <Autocomplete
                    size="small"
                    disablePortal
                    options={ubicaciones.map((item) => ({
                      id: item.id,
                      label: item.descripcion,
                    }))}
                    value={selectedUbicacion}
                    onChange={(event, newValue) => setSelectedUbicacion(newValue)}
                    renderInput={(params) => <TextField {...params} label="Ubicacion" />}
                  />
                  <Autocomplete
                    size="small"
                    disablePortal
                    options={negocios.map((item) => ({
                      id: item.id,
                      label: item.descripcion,
                    }))}
                    value={selectedNegocio}
                    onChange={(event, newValue) => setSelectedNegocio(newValue)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Negocio"
                        InputProps={{
                          ...params.InputProps,
                          startAdornment: (
                            <>
                              <StorefrontIcon sx={{ mr: 0.5, fontSize: 16, color: "action.active" }} />
                              {params.InputProps.startAdornment}
                            </>
                          ),
                        }}
                      />
                    )}
                  />
                </Box>
              </CardContent>
            </Card>

            <Card elevation={2} sx={{ borderRadius: 1.5 }}>
              <CardContent sx={{ p: 1, "&:last-child": { pb: 1 } }}>
                <Typography sx={{ mb: 0.75, fontSize: 12, fontWeight: 700 }}>
                  Usuario y facturacion
                </Typography>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 0.75 }}>
                  <Autocomplete
                    size="small"
                    disablePortal
                    options={usuarios.map((item) => ({
                      label: `${item.usuario} ${item.nombre || ""} ${item.apellido || ""}`,
                      nombre: item.nombre,
                      apellido: item.apellido,
                      id: item.id,
                      usuario: item.usuario,
                    }))}
                    value={usuarioSeleccionado}
                    onChange={(event, newValue) => setUsuarioSeleccionado(newValue)}
                    renderInput={(params) => <TextField {...params} label="Usuario" />}
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={!checkboxFacturaNegro}
                        onChange={(event) => {
                          setCheckboxFacturaNegro(!event.target.checked)
                        }}
                        size="small"
                      />
                    }
                    label={<Typography sx={{ fontSize: 12 }}>F de facturar</Typography>}
                    sx={{ ml: 0 }}
                  />
                </Box>
              </CardContent>
            </Card>
          </Box>
        )}

        {activeTab === "payment" && (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            <Card elevation={2} sx={{ borderRadius: 1.5 }}>
              <CardContent sx={{ p: 1, "&:last-child": { pb: 1 } }}>
                <Typography sx={{ mb: 0.75, fontSize: 12, fontWeight: 700, display: "flex", alignItems: "center", gap: 0.5 }}>
                  <ReceiptIcon sx={{ fontSize: 16 }} />
                  Resumen
                </Typography>

                <Box sx={{ backgroundColor: alpha(theme.palette.primary.light, 0.08), p: 1, borderRadius: 1 }}>
                  <Box sx={{ display: "flex", justifyContent: "space-between", mb: 0.5 }}>
                    <Typography sx={{ fontSize: 12 }}>Subtotal</Typography>
                    <Typography sx={{ fontSize: 12, fontWeight: 700 }}>
                      {new Intl.NumberFormat("es-AR", { style: "currency", currency: "ARS" }).format(precioBaseTotal)}
                    </Typography>
                  </Box>

                  <FormControlLabel
                    control={
                      <Checkbox
                        size="small"
                        checked={aplicarDescuento}
                        onChange={(event) => {
                          const isChecked = event.target.checked
                          setAplicarDescuento(isChecked)
                          if (!isChecked) limpiarDescuentosItems()
                        }}
                      />
                    }
                    label={<Typography sx={{ fontSize: 12 }}>Aplicar descuento</Typography>}
                    sx={{ ml: 0 }}
                  />

                  <Collapse in={aplicarDescuento}>
                    <Box sx={{ display: "flex", gap: 0.5, alignItems: "center", mb: 0.5 }}>
                      <TextField
                        size="small"
                        type="number"
                        value={tempPorcentajeDescuento}
                        onChange={(event) => setTempPorcentajeDescuento(event.target.value)}
                        onBlur={applyDiscounts}
                        label="Descuento %"
                        InputProps={{
                          inputProps: { step: 0.01 },
                          endAdornment: <InputAdornment position="end">%</InputAdornment>,
                        }}
                        fullWidth
                      />
                      <Tooltip title="Limpiar descuentos">
                        <IconButton size="small" onClick={limpiarDescuentosItems}>
                          <RestartAltIcon sx={{ fontSize: 16 }} />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  </Collapse>

                  <FormControlLabel
                    control={
                      <Checkbox
                        size="small"
                        checked={aplicarInteres}
                        onChange={(event) => {
                          const isChecked = event.target.checked
                          setAplicarInteres(isChecked)
                          if (!isChecked) limpiarInteresesItems()
                        }}
                      />
                    }
                    label={<Typography sx={{ fontSize: 12 }}>Aplicar interés</Typography>}
                    sx={{ ml: 0 }}
                  />

                  <Collapse in={aplicarInteres}>
                    <Box sx={{ display: "flex", gap: 0.5, alignItems: "center", mb: 0.5 }}>
                      <TextField
                        size="small"
                        type="number"
                        value={tempPorcentajeInteres}
                        onChange={(event) => setTempPorcentajeInteres(event.target.value)}
                        onBlur={applyInterest}
                        label="Interés %"
                        InputProps={{
                          inputProps: { step: 0.01 },
                          endAdornment: <InputAdornment position="end">%</InputAdornment>,
                        }}
                        fullWidth
                      />
                      <Tooltip title="Limpiar intereses">
                        <IconButton size="small" onClick={limpiarInteresesItems}>
                          <RestartAltIcon sx={{ fontSize: 16 }} />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  </Collapse>

                  {montoTotalDescuentos > 0 && (
                    <Box sx={{ display: "flex", justifyContent: "space-between", color: "error.main", mb: 0.5 }}>
                      <Typography sx={{ fontSize: 12 }}>Descuentos</Typography>
                      <Typography sx={{ fontSize: 12, fontWeight: 700 }}>
                        -{new Intl.NumberFormat("es-AR", { style: "currency", currency: "ARS" }).format(montoTotalDescuentos)}
                      </Typography>
                    </Box>
                  )}

                  {montoTotalIntereses > 0 && (
                    <Box sx={{ display: "flex", justifyContent: "space-between", color: "success.main", mb: 0.5 }}>
                      <Typography sx={{ fontSize: 12 }}>Intereses</Typography>
                      <Typography sx={{ fontSize: 12, fontWeight: 700 }}>
                        +{new Intl.NumberFormat("es-AR", { style: "currency", currency: "ARS" }).format(montoTotalIntereses)}
                      </Typography>
                    </Box>
                  )}

                  <Divider sx={{ my: 0.5 }} />

                  {!aceptarImpuestos &&
                    checkboxFacturaNegro === false &&
                    impuestos &&
                    Array.isArray(impuestos) &&
                    impuestos.length > 0 &&
                    impuestos
                      .filter((impuesto) => !impuesto.eliminado && !impuesto.incluidoEnPrecio)
                      .map((impuesto) => {
                        const montoImpuesto = (precioBaseTotal * impuesto.porcentaje) / 100
                        return (
                          <Box key={impuesto.id} sx={{ display: "flex", justifyContent: "space-between", mb: 0.25 }}>
                            <Typography sx={{ fontSize: 11 }}>
                              {impuesto.descripcion} ({impuesto.porcentaje}%)
                            </Typography>
                            <Typography sx={{ fontSize: 11 }}>
                              {new Intl.NumberFormat("es-AR", { style: "currency", currency: "ARS" }).format(montoImpuesto)}
                            </Typography>
                          </Box>
                        )
                      })}

                  <Divider sx={{ my: 0.5 }} />

                  <Box sx={{ display: "flex", justifyContent: "space-between", mt: 0.5 }}>
                    <Typography sx={{ fontWeight: 700, fontSize: 13 }}>Total</Typography>
                    <Typography sx={{ fontWeight: 700, fontSize: 13, color: "success.main" }}>
                      {new Intl.NumberFormat("es-AR", { style: "currency", currency: "ARS" }).format(precioTotal)}
                    </Typography>
                  </Box>
                </Box>

                {checkboxFacturaNegro === false && (
                  <Autocomplete
                    size="small"
                    disablePortal
                    options={tiposFacturas || []}
                    getOptionLabel={(option) => option?.descripcion || ""}
                    value={idTipoFactura}
                    onChange={(event, newValue) => setIdTipoFactura(newValue)}
                    renderInput={(params) => <TextField {...params} label="Tipo de factura" sx={{ mt: 0.75 }} />}
                  />
                )}
              </CardContent>
            </Card>

            <Card elevation={2} sx={{ borderRadius: 1.5 }}>
              <CardContent sx={{ p: 1, "&:last-child": { pb: 1 } }}>
                <Typography sx={{ mb: 0.75, fontSize: 12, fontWeight: 700, display: "flex", alignItems: "center", gap: 0.5 }}>
                  <PaymentsIcon sx={{ fontSize: 16 }} />
                  Medios de pago
                </Typography>

                <Autocomplete
                  size="small"
                  disablePortal
                  options={tipoMedioDePago || []}
                  getOptionLabel={(option) => option?.descripcion || ""}
                  value={selectedTipoMedioDePago}
                  onChange={(event, newValue) => setSelectedTipoMedioDePago(newValue)}
                  renderInput={(params) => <TextField {...params} label="Tipo medio pago" />}
                />

                {mostrarButtonModalMedioDePago && (
                  <Button
                    size="small"
                    variant="outlined"
                    startIcon={<VisibilityIcon sx={{ fontSize: 16 }} />}
                    onClick={handleAbrirModalMedioDePago}
                    sx={{ mt: 0.75 }}
                    fullWidth
                  >
                    Ver medios seleccionados
                  </Button>
                )}

                <Collapse in={openCollapse}>
                  <Autocomplete
                    size="small"
                    disablePortal
                    options={medioDePagoIdTipoEspecifico || []}
                    getOptionLabel={(option) => option?.descripcion || ""}
                    value={selectedMedioDePago || null}
                    onChange={(event, newValue) => setSelectedMedioDePago(newValue)}
                    renderInput={(params) => <TextField {...params} label="Medio especifico" sx={{ mt: 0.75 }} />}
                  />
                </Collapse>

                <Divider sx={{ my: 0.75 }} />

                <Box sx={{ display: "flex", justifyContent: "space-between", mb: 0.4 }}>
                  <Typography sx={{ fontSize: 12, fontWeight: 700 }}>Total</Typography>
                  <Typography sx={{ fontSize: 12, fontWeight: 700, color: "success.main" }}>
                    {new Intl.NumberFormat("es-AR", { style: "currency", currency: "ARS" }).format(precioTotal)}
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography sx={{ fontSize: 12 }}>Pagado</Typography>
                  <Typography sx={{ fontSize: 12, fontWeight: 700 }}>
                    {new Intl.NumberFormat("es-AR", { style: "currency", currency: "ARS" }).format(cantidaMedioDePagoList)}
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Box>
        )}
      </Box>

      <Box sx={{ p: 1, backgroundColor: "white", borderTop: "1px solid #e0e0e0" }}>
        {activeTab === "config" ? (
          <Button
            fullWidth
            variant="contained"
            size="small"
            disabled={!canGoToPayment}
            onClick={() => {
              handleSetTab("payment")
              if (onGoToPayment) onGoToPayment()
            }}
          >
            Ir a pago
          </Button>
        ) : (
          <Button
            fullWidth
            variant="contained"
            size="small"
            disabled={isConfirmDisabled}
            onClick={onConfirmarPago}
            startIcon={<PointOfSaleIcon sx={{ fontSize: 16 }} />}
            sx={{ backgroundColor: "green" }}
          >
            Confirmar pago
          </Button>
        )}
      </Box>
    </Box>
  )
}

export default VentaCrearMobilePanel
